import { createElement, Fragment } from 'react';
import ReactCropper from 'react-cropper';
import { CropperProps } from '.';
import 'cropperjs/dist/cropper.css';
import cx from 'classnames';
import cn from './Cropper.css.json';
import './Cropper.css';

/**
 * @internal
 */
export const Cropper = (props: CropperProps) => {
  return props.src.length > 0 ? (
    <Fragment>
      <img src={props.src} onError={props.onError} className={cn.invisibleImage} />
      <ReactCropper
        key={props.cropperKey}
        className={cx(cn.cropper, props.ellipse && cn.ellipse, props.className)}
        onInitialized={(cropper) => {
          if (props.cropperRef) {
            props.cropperRef.current = cropper;
          }
        }}
        viewMode={2}
        dragMode="none"
        toggleDragModeOnDblclick={false}
        preview={props.previewClassName ? `.${props.previewClassName}` : undefined}
        minCropBoxWidth={1}
        minCropBoxHeight={1}
        src={props.src}
        aspectRatio={props.aspectRatio ?? 1}
        guides={false}
        ready={props.onReady}
      />
    </Fragment>
  ) : null;
};
